import { render, staticRenderFns } from "./CredentialsTable.vue?vue&type=template&id=71ec1a7a&scoped=true&"
import script from "./CredentialsTable.vue?vue&type=script&lang=js&"
export * from "./CredentialsTable.vue?vue&type=script&lang=js&"
import style0 from "./CredentialsTable.vue?vue&type=style&index=0&id=71ec1a7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ec1a7a",
  null
  
)

export default component.exports